type ShouldLoadUserDetailsArgs = {
    userId: bigint | null | undefined;
    inViewPort: boolean;
    shouldLoadInlineData: boolean;
    shouldLoadPopoverData: boolean;
};

type ShouldLoadInlineUserDataArgs = {
    name: string | null | undefined;
    photoUrl: string | null | undefined;
    showAvatar: boolean;
};

type ShouldLoadAlertDetailsArgs = {
    inViewPort: boolean;
    hasCachedData: boolean;
    indicatorColor: string | null | undefined;
    isPopoverOpen: boolean;
};

export type AlertDetailsCacheIdentity = {
    id: bigint;
    entity: 'incident' | 'complaint';
    indicatorColor: string | null | undefined;
};

export function shouldLoadInlineUserData({ name, photoUrl, showAvatar }: ShouldLoadInlineUserDataArgs) {
    return !name || (showAvatar && !photoUrl);
}

export function shouldLoadUserDetails({
    userId,
    inViewPort,
    shouldLoadInlineData,
    shouldLoadPopoverData,
}: ShouldLoadUserDetailsArgs) {
    return Boolean(userId && inViewPort && (shouldLoadInlineData || shouldLoadPopoverData));
}

export function shouldLoadAlertDetails({
    inViewPort,
    hasCachedData,
    indicatorColor,
    isPopoverOpen,
}: ShouldLoadAlertDetailsArgs) {
    return inViewPort && !hasCachedData && (indicatorColor === undefined || isPopoverOpen);
}

export function matchesAlertDetailsCache(
    cachedIdentity: AlertDetailsCacheIdentity | undefined,
    currentIdentity: AlertDetailsCacheIdentity,
) {
    return Boolean(
        cachedIdentity &&
            cachedIdentity.id === currentIdentity.id &&
            cachedIdentity.entity === currentIdentity.entity &&
            cachedIdentity.indicatorColor === currentIdentity.indicatorColor,
    );
}
